module.exports = __webpack_public_path__ + "static/media/card-1.6ee66b2c.jpeg";